/*
 * Inits the builder showcase about page
 */
define(
  'aboutInitializer',[
    'frequentlyAskedQuestionsHandler',
    'searchBoxHandler',
    'dependenciesLoader',
    'favoritesLoader',
    'analyticsHelper',
    'longTextHandler',
    'builderShowcaseReviewsStarFilterHandler',
    'searchTypeHelper'
  ],
  () => {
    'use strict';
  }
);

